import "./styleSheet.css?v=1";
import actions from "./actions";
import view from "./view";
import state from "./state";

global.cabchargeStart = function () {
	const app = window.hyperapp.app;
	const node = window.window.hyperapp.h;

	const appActions = app(state, actions, view, document.getElementById("app"));

	global.cabchargeOnBlur = appActions.onBlur;

	if (module.hot) {
		module.hot.accept();
	}

	appActions.onLoad();
};